import { useStore } from '@nanostores/react';
import { useEffect, useRef, useState } from 'react';
import { OpenAPI } from '../../api/core/OpenAPI';
import { request as __request } from '../../api/core/request';

export const WhatsAppOAuthRedirectHandler = () => {
  const org = useStore($org);
  const effectRunRef = useRef(false);
  const [message, setMessage] = useState('Processing WhatsApp Authentication...');

  useEffect(() => {
    if (!org || effectRunRef.current) return; // Prevent duplicate execution
    effectRunRef.current = true;

    const handleWhatsAppCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');

      const orgId = org?.id || localStorage.getItem('whatsapp_org_id');

      if (!code) {
        console.error('Invalid state or missing authorization code.');
        setMessage('Authentication failed: Missing authorization code.');
        return;
      }

      if (!orgId) {
        console.error('Invalid state or missing organization ID.');
        setMessage('Authentication failed: Missing organization ID.');
        return;
      }

      const body: {
        Code: string;
        State: string;
        OrgId?: string;
      } = {
        Code: code,
        State: state ?? '',
        OrgId: orgId,
      };

      try {
        await __request(OpenAPI, {
          method: 'POST',
          url: `/integrations/whatsapp/getAccessToken`,
          body,
          mediaType: 'application/json',
        });
        setMessage('Authentication successful, redirecting to integrations...');
        localStorage.removeItem('whatsapp_org_id'); // Clean up
        window.location.href = `/settings?activeNav=integrations`;
      } catch (error) {
        setMessage('Authentication unsuccessful, please try again.');
        localStorage.removeItem('whatsapp_org_id'); // Clean up even on error
        window.location.href = `/settings?activeNav=integrations`;
        console.error('Error during WhatsApp authentication callback:', error);
      }
    };

    handleWhatsAppCallback();
  }, [org]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};
